/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ACCORDION CODE
function openAccordion(evt, accordionItem, forceOpen) {
    // Declare all variables
    var i, tabcontent, tablinks;

    // if we really want to open, and not toggle
    if (forceOpen && evt.currentTarget.classList.contains('accordion-toggle-active')) {
        return;
    }

    if(evt.currentTarget.classList.contains('accordion-toggle-active')) {
        evt.target.classList.remove('accordion-toggle-active');
        document.getElementById(accordionItem).classList.remove('accordion-content-active');
        return;
    }

    // Get all elements with class="accordionContent" and hide them
    accordionContent = document.getElementsByClassName("accordion-content");
    for (i = 0; i < accordionContent.length; i++) {
        accordionContent[i].classList.remove('accordion-content-active');
    }

    // Get all elements with class="accordionToggles" and remove the class "accordion-toggle-active"
    accordionToggle = document.getElementsByClassName("accordion-toggle");
    for (i = 0; i < accordionToggle.length; i++) {
        accordionToggle[i].className = accordionToggle[i].className.replace(" accordion-toggle-active", "");
    }

    // Show the current accordionContent, and add an "active" class to the button that opened the accordion
    document.getElementById(accordionItem).classList.add('accordion-content-active');
    evt.currentTarget.className += " accordion-toggle-active";
}

// const el = document.querySelector("#shopify-section-header")
// const observer = new IntersectionObserver( 
//   ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
//   { threshold: 0 }
// );

// observer.observe(el);


document.addEventListener('sticky-change', e => {
    const header = e.detail.target;
    const sticking = e.detail.stuck; 
    header.classList.toggle('is-sticky', sticking);
});

jQuery(document).ready(function($) {
    var anchorLink = $(window.location.hash);
    if ( anchorLink.length ) {
        var offsetSize = $("header").innerHeight();
        $("html, body").animate({scrollTop: anchorLink.offset().top - offsetSize }, 500);
    }
});

$( document ).ready(function() {
    var modal = document.getElementById("StoreSelector_Modal");
    var btn = document.getElementById("StoreSelector_Btn");
    var span = document.getElementById("StoreSelector_Modal-close");

    if (btn) {
        btn.onclick = function() {
            modal.style.display = "block";
        }
        span.onclick = function() {
            modal.style.display = "none";
        }
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    }
    
});
